const t = {
  "horizontal-center": "horizontal-center"
};
export {
  t as default
};
